import { Container, Col } from "react-bootstrap";
import { TelephoneForward, At, GeoAlt, Whatsapp } from "react-bootstrap-icons";
import { RevealGroup, RevealItem } from "../ui/Reveal";
import ContactForm from "./ContactForm";
import "../style/ThreeColContactus.css";

const WHATSAPP_HREF =
  "https://api.whatsapp.com/send?phone=916363018056&text=Hi%2C%20I%27d%20like%20to%20get%20in%20touch.";

const Contactus = () => {
  return (
    <section className="section-pad contactus">
      <Container className="container-narrow">
        <RevealGroup className="row g-4">
          <Col lg={5}>
            <RevealItem className="contactus__info card-surface">
              <h2>Meet Us</h2>
              <p className="contactus__row">
                <Whatsapp size={18} className="contactus__icon" />
                <a href={WHATSAPP_HREF} target="_blank" rel="noreferrer">
                  WhatsApp Us
                </a>
              </p>
              <p className="contactus__row">
                <TelephoneForward size={18} className="contactus__icon" />
                <a href="tel:+916363018056">+91 63630 18056</a>
              </p>
              <p className="contactus__row">
                <At size={18} className="contactus__icon" />
                <a href="mailto:bitbytefoods@gmail.com">bitbytefoods@gmail.com</a>
              </p>
              <p className="contactus__row contactus__row--address">
                <GeoAlt size={18} className="contactus__icon" />
                Kote Cafe (formerly Idly Dosa Camp), Shop 2, Jain Mandir
                Complex, Vidyagiri, Bagalkot, Karnataka 587102
              </p>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3831.952523510548!2d75.65902471477932!3d16.17139848881794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc7797d049a228d%3A0x39bb416c679f0b32!2sBB's%20Idly%20Dosa%20Camp!5e0!3m2!1sen!2sin!4v1679032424386!5m2!1sen!2sin"
                className="contactus__map"
                title="Kote Cafe (formerly Idly Dosa Camp) location"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </RevealItem>
          </Col>
          <Col lg={7}>
            <RevealItem delay={80} className="contactus__form card-surface">
              <h2>Send a Message</h2>
              <p className="contactus__form-subtitle">
                Questions about the batter, retail, or Kote Cafe? Drop us a
                line and we&apos;ll get back to you.
              </p>
              <ContactForm />
            </RevealItem>
          </Col>
        </RevealGroup>
      </Container>
    </section>
  );
};

export default Contactus;
